import { environment } from '@/utils/env.utils';

const { marketingSiteUrl: url } = environment;

const marketingSiteRouteMap = {
  home: url,
  contact: `${url}/contact`,
  faq: `${url}/faq`,
  termsAndConditions: `${url}/terms-and-conditions`,
  integrity: `${url}/integrity`,
  aboutFairlo: `${url}/about-fairlo`,
  idProtectTermsPdf: `${url}/documents/fairlo-personskydd-allmänna-villkor.pdf`,
};

export default marketingSiteRouteMap;
